import Spine from 'core/display/Spine'
import { reelsSettings, spinSettings } from 'settings/custom/reels'
import { create } from 'utils/Object'

const { items } = reelsSettings
const { animation } = spinSettings

export class AnimationExplosion extends Spine {
  constructor(i) {
    super(create(items, animation))

    this.play()
    this.scale.set(0.5)
    this.y = (i * items.height / 2 ) + items.height / 4

    this.x = items.width / 4
  }
}
